import React from "react";

import { Form } from "react-bootstrap";

import DatePicker, { registerLocale } from "react-datepicker";

import es from "date-fns/locale/es";

export const DatePickerInput = ({ label, fechaSeleccionada, onChangeDatePicker }) => {
  registerLocale("es", es);
  return (
    <Form.Group className="mb-3">
      <Form.Label className="label-forms-admin">{label}</Form.Label>
      <DatePicker
        locale="es"
        className="inputs-forms-admin focus-admin-register date-picker_geomedellin calendar-icon"
        selected={fechaSeleccionada}
        maxDate={new Date()}
        placeholderText={"DD/MM/AAAA"}
        dateFormat="dd/MM/yyyy"
        onChange={(update) => {
          onChangeDatePicker(update);
        }}
        isClearable={true}
      />
    </Form.Group>
  );
};
